import React from 'react'

import { Box, Container, Link, Typography } from '@material-ui/core'
import { Route, Switch } from 'wouter'

import usePageScrollTracker from 'artkive/components/Tracker/usePageScrollTracker'
import withApp from 'artkive/hoc/withApp'
import routes from 'artkive/utils/routes'

import LatestBody from './LatestBody'
import V20240710Body from './V20240710Body'
import V20250128Body from './V20250128Body'
import V20250728Body from './V20250728Body'
import V20260319Body from './V20260319Body'
import V20260602Body from './V20260602Body'

const Tou = () => {
  usePageScrollTracker()

  return (
    <Box py={10}>
      <Container>
        <Box>
          <Typography align='center' variant='h2'>
            Terms of Use
          </Typography>
          <br />
          <ul>
            <li>
              <Link href={routes.tou}>
                <strong>Updated Terms of Use</strong>
              </Link>
            </li>
            <li>
              <Link href={routes.tou + '/2026-06-02'}>
                <strong>Previous Terms of Use March 20, 2026 - June 2, 2026</strong>
              </Link>
            </li>
            <li>
              <Link href={routes.tou + '/2026-03-19'}>
                <strong>Previous Terms of Use July 29, 2025 - March 19, 2026</strong>
              </Link>
            </li>
            <li>
              <Link href={routes.tou + '/2025-07-28'}>
                <strong>Previous Terms of Use Jan 29, 2025 - July 28, 2025</strong>
              </Link>
            </li>
            <li>
              <Link href={routes.tou + '/2025-01-28'}>
                <strong>Previous Terms of Use July 11, 2024 - Jan 28, 2025</strong>
              </Link>
            </li>
            <li>
              <Link href={routes.tou + '/2024-07-10'}>
                <strong>Previous Terms of Use May 24, 2022 - July 10, 2024</strong>
              </Link>
            </li>
          </ul>
          <br />
          <hr />
          <br />
          <Switch>
            <Route path={routes.tou + '/2026-06-02'} component={V20260602Body} />
            <Route path={routes.tou + '/2026-03-19'} component={V20260319Body} />
            <Route path={routes.tou + '/2025-07-28'} component={V20250728Body} />
            <Route path={routes.tou + '/2025-01-28'} component={V20250128Body} />
            <Route path={routes.tou + '/2024-07-10'} component={V20240710Body} />
            <Route component={LatestBody} />
          </Switch>
        </Box>
      </Container>
    </Box>
  )
}

export default withApp(Tou)
